module.exports = __webpack_public_path__ + "img/allDoneGif.33c6cb4f.gif";